import styled from 'styled-components';

export const DashboardContainer = styled.div`
  width: 100%;
  height: 100%;

  h1 {
    font-weight: 700;
    font-size: 19px;
    line-height: 23px;
    letter-spacing: 0.4px;
    color: ${({theme}) => theme.accent};
    margin-top: 42px;
  }
`;

export const GreetingContainer = styled.div`
  background: ${({theme}) => theme.white};
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 0 32px 0 32px;
  margin-bottom: 20px;
  margin-right: 20px;
  max-height: 140px;
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    max-height: unset;
    padding: 32px;
    width: 100%;
  }

  h1 {
    font-size: 24px;
    color: ${({theme}) => theme.accent};
    font-weight: 700;
    margin-bottom: 12px;
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      margin-top: 0;
    }
  }

  p {
    color: ${({theme}) => theme.grayDark};
    font-size: 16px;
    font-weight: 400;
  }
`;

export const GreetingImageContainer = styled.div`
  svg {
    position: relative;
    top: -17px;
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      display: none;
    }
  }
`;

type StatusProps = {
    color: string;
};

export const PendingRegistrationsContainer = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  margin-bottom: 0;
  @media (max-width: ${({theme}) => theme.breakpoints.xxl}) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }

`

export const PayrollContainer = styled.div`
  width: 40%;
  @media (max-width: ${({theme}) => theme.breakpoints.xxl}) {
    width: 100%;
`

export const Status = styled.span<StatusProps>`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 5px 12px;
  border-radius: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  text-transform: uppercase;
  color: #ffffff;
  letter-spacing: 0.5px;
  background: ${({color}) => color};
`;

export const EmployeeIdentification = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  img {
    margin-right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
      display: none;
    }
  }

  h3 {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${({theme}) => theme.accent};
  }

  h4 {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.1px;
    color: ${({theme}) => theme.grayDark};
  }
`

export const EmployeeAddress = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: start;
  justify-content: space-between;
  
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    align-items: center;
    justify-content: center;
  }
  
  h3{
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${({theme}) => theme.accent};
    @media (max-width: ${({theme}) => theme.breakpoints.md}) {
      display: none;
    }
  }
`

interface EmployeeCountryProps {
    countryName: string;
    countryCode: string
}


export const EmployeeCountry = styled.div<EmployeeCountryProps>`
    width: 100% ;
    display: flex;
    justify-content: start;
    align-items: center;
    h6{
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.1px;
      color: ${({theme}) => theme.grayLight};
      
      &::after{
        content: "${({countryName}) => countryName}";
      }
      
      @media (max-width: ${({theme}) => theme.breakpoints.md}) {
        &::after{
          content: "${({countryCode}) => countryCode}";
        }
      }
   
    }
  
`



